import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
  RouterProvider,
} from 'react-router-dom';
import {
  CheckIsMobile,
  InitialRedirect,
  RequireLastSearch,
} from 'features/index';
import { PageError, PageMain, PageSchedule } from 'pages/index';
import { BASE, MAIN_PAGE, SCHEDULE_PAGE } from 'shared/consts';
import { LayoutMain, LayoutSchedule } from 'widgets/index';

export const AppRouter = () => {
  const routers = createRoutesFromElements(
    <Route path={BASE} errorElement={<PageError />}>
      <Route element={<CheckIsMobile />}>
        <Route path={BASE} element={<InitialRedirect />} />
        <Route element={<LayoutMain />}>
          <Route path={MAIN_PAGE} element={<PageMain />} />
        </Route>
        <Route element={<LayoutSchedule />}>
          <Route
            path={SCHEDULE_PAGE}
            element={
              <RequireLastSearch>
                <PageSchedule />
              </RequireLastSearch>
            }
          />
        </Route>
      </Route>
    </Route>,
  );

  const router = createBrowserRouter(routers, {});

  return <RouterProvider router={router} />;
};
